module.exports = __webpack_public_path__ + "static/media/2.a5e0eff0.jpg";